import type { SVGProps } from "react";
import * as React from "react";

export const ArrowDropDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12 15-5-5h10z"
    />
  </svg>
);
